export default "__VITE_ASSET__BCst_Cu3__"